import { createAsyncThunk } from '@reduxjs/toolkit'
import ExploreMediaService from '@internal/services/explore-media'
import { GetMediaDetailQueryParam } from '@shared/Services/QueryParamService'
import { IReduxThunkReturned } from './redux.types'

export const fetchMediaDetailThunk = createAsyncThunk<IReduxThunkReturned>('fetchMediaDetailThunk', async (params, thunkAPI) => {
  const defaultValue: IReduxThunkReturned = { recommendProducts: [], prices: [], categories: [] }
  const qParam = GetMediaDetailQueryParam()
  if (!qParam.id) return defaultValue
  const res = await ExploreMediaService.detailPageById(qParam.id, { type: qParam.type, sort: 'Lastet', pagination: { page: 1, pageSize: 12 } })

  return {
    productInfo: res.media,
    recommendProducts: res.medias,
    prices: res.prices,
    categories: res.categories
  }
})
